import { useProviderSearchStore } from "../store/providerSearchStore";

export function useFilterConfig() {
  const { providerName, setProviderName, providerType, setProviderType } = useProviderSearchStore();

  return [
    {
      id: "group1",
      layout: "flex-row",
      fields: [
        {
          id: "providerName",
          fieldLabel: "Provider Name:",
          fieldType: "TEXTFIELD",
          placeholder: "Write name",
          searchText: providerName,
          setSearchText: setProviderName,
          width: "w-full",
        },
      ],
    },
    {
      id: "group2",
      layout: "flex-row",
      align: "items-start",
      fields: [
        {
          id: "providerType",
          fieldLabel: "Provider Type:",
          fieldType: "PROVIDER_TYPE",
          placeholder: "Select an Option",
          providerTypeFilter: providerType,
          setProviderTypeFilter: setProviderType,
          width: "w-full",
        },
      ],
    },
    {
      id: "group3",
      layout: "flex-row",
      fields: [
        {
          id: "filter",
          fieldLabel: "",
          fieldType: "FILTER",
          placeholder: "",
          width: "w-1/6",
        },
        {
          id: "clientAddress",
          fieldLabel: "Address:",
          fieldType: "AUTOCOMPLETE",
          width: "w-5/6",
        },
      ],
    },
  ];
}
